<template>
<div class="layout-extra-sidebar">
  <ul>
      <li v-for="menu in menuList" :key="menu.index" :class="{active: isActiveMenu(menu.id)}" class="layout-sidebar-moduleItem">
        <a @click.prevent="handleMenuChange(menu)" :href="menu.url">{{menu.name}}</a>
      </li>
    </ul>
</div>
</template>

<script>
import { filterMenuList, forEachMenuList } from '../utils';
import extraMenuTree from './extraMenuTree';

export default {
  components: {},
  props: {
    type: {
      type: String,
      required: true,
    },
    system: {
      type: String,
      default: '',
    },
    privilege: {
      type: Object,
      default: () => ({}),
    },
    setting: {
      type: Object,
      default: () => ({}),
    },
    onCreateMenu: {
      type: Function,
      default: menu => menu,
    },
  },
  computed: {
    menuList() {
      const menuList = filterMenuList({
        menuList: extraMenuTree[this.type],
        privilege: this.privilege,
        setting: this.setting,
      });

      forEachMenuList(menuList, menu => {
        this.onCreateMenu(menu);
      });

      return menuList;
    },
    flatMenuObject() {
      const flatMenuObject = {};
      forEachMenuList(this.menuList, menu => {
        flatMenuObject[menu.id] = menu;
      });
      return flatMenuObject;
    },
    activeIds() {
      const activeIds = [];
      Object.values(this.flatMenuObject).forEach(menuItem => {
        const { system, $router, $route } = this;
        const { url, id, system: menuSystem, parentMenu } = menuItem;
        // system相同、解析的url相同 或者 路由的meta里硬编码了要高亮的id
        const isActive =
          (!!url &&
            system === menuSystem &&
            $router.resolve(url).resolved.name ===
              $router.resolve($route.path).resolved.name) ||
          $route.meta.menuId === id;
        if (isActive) {
          activeIds.push(id);
          if (parentMenu && parentMenu.length) {
            activeIds.push(...parentMenu);
          }
        }
      });
      return activeIds;
    },
  },
  methods: {
    isActiveMenu(id) {
      return this.activeIds.includes(id);
    },
    handleMenuChange(menu) {
      if (menu.system === this.system) {
        this.$router.push(menu.url);
      } else {
        const isTW = window.location.host.includes('okki.com');
        let menuUrl = `${process.env.HOSTS[menu.system]}${menu.url}`;
        if (isTW) {
          menuUrl = menuUrl.replace('xiaoman.cn', 'okki.com');
        }
        window.open(menuUrl, '_self');
      }
    },
  },
};
</script>

<style lang="scss">
.layout-extra-sidebar {
  width: 200px;
  flex: none;
  background: #fffefe;
  border-right: 1px solid #b6b6b6;
  box-shadow: 0 2px 4px 0 rgba(0, 5, 8, 0.07);

  > ul {
    li {
      &.active {
        a {
          color: #0884f3;
          background: #ecf4fd;
        }
      }

      &:hover {
        a {
          background: #f0f0f0;
        }
      }

      a {
        height: 40px;
        line-height: 40px;
        padding: 0 20px;
        display: block;
      }
    }
  }
}
</style>
